import { WithConnectedDashboard } from 'components/dashboard/Dashboard.connected';
import { ConnectedTabsWorkspace } from 'components/shared/DragAndDropWorkspace/TabsWorkspace';
import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import { workspaceTabCreatedThunk } from 'state/workspaces/workspace.thunks';

import { DynamicQuotesTab } from './DynamicQuotesTab';
export const DynamicQuotesWorkspace: FC = () => {
  const dispatch = useDispatch<ThunkDispatch>();
  const onAddNewTab = useCallback(() => {
    dispatch(workspaceTabCreatedThunk('dynamic', 'quote'));
  }, [dispatch]);
  return (
    <ConnectedTabsWorkspace workspace="dynamic" onAddNewTab={onAddNewTab} paddingClassName="ps-2">
      {(tab, isDashboardActive, onHideDashboard) => (
        <WithConnectedDashboard isActive={isDashboardActive} onHide={onHideDashboard}>
          {tab?.id && <DynamicQuotesTab tabId={tab?.id} />}
        </WithConnectedDashboard>
      )}
    </ConnectedTabsWorkspace>
  );
};

DynamicQuotesWorkspace.displayName = 'DynamicQuotesWorkspace';
